"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitsOnlyDirective = void 0;
const core_1 = require("@angular/core");
/**
 * Digits Only Directive
 *
 * Only allows digits in text field
 */
class DigitsOnlyDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        // List of keys to allow
        this.allowedNavigationKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'ArrowLeft',
            'ArrowRight',
            'Control',
            'Meta'
        ];
        // Command keys allowed
        this.allowedCommandKeys = [
            'a',
            'c',
            'v',
            'x'
        ];
        this.inputElement = elementRef.nativeElement;
    }
    // Listen to the keydown event
    onKeyDown(e) {
        // Allow: navigation keys: backspace, delete, arrows etc.
        if (this.allowedNavigationKeys.indexOf(e.key) > -1 || (this.allowedCommandKeys.indexOf(e.key) > -1 && (e.ctrlKey || e.metaKey))) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((['e', 'E', '+', '-'].includes(e.key)) || e.key === ' ' || isNaN(Number(e.key))) {
            e.preventDefault();
        }
    }
}
exports.DigitsOnlyDirective = DigitsOnlyDirective;
//# sourceMappingURL=digitsOnly.directive.js.map